import { render, staticRenderFns } from "./MyAccountSettingsIcon.vue?vue&type=template&id=425afc1e&scoped=true"
import script from "./MyAccountSettingsIcon.vue?vue&type=script&lang=js"
export * from "./MyAccountSettingsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425afc1e",
  null
  
)

export default component.exports